import { useNavigate } from 'react-router-dom';
import { CaretLeft } from '@phosphor-icons/react';

import pt from '../../locales/pt';

/**
 * Barra fixa no topo (auth, termos, privacidade) — .pen topbar.
 */
export function AuthTopBar({ title, backTo = '/', onBack }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    navigate(backTo);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-30 border-b border-border bg-card/80 backdrop-blur">
      <div className="container-app grid h-14 grid-cols-[2.25rem_1fr_2.25rem] items-center gap-space-3">
        <button
          type="button"
          onClick={handleBack}
          className="flex size-9 items-center justify-center rounded-ds-full text-foreground transition-colors hover:bg-muted"
          aria-label={pt.nav.back}
        >
          <CaretLeft className="size-[17px]" weight="regular" aria-hidden />
        </button>
        <h1 className="truncate text-center font-display text-type-display-stat font-semibold text-foreground">
          {title}
        </h1>
        <span className="size-9" aria-hidden />
      </div>
    </header>
  );
}
